import { env } from "@src/env.mjs";

const generateAssetUrl = (id?: string, assetSize?: "small" | "original") => {
  return (
    "" +
    env.NEXT_PUBLIC_ASSETS_URL +
    env.NEXT_PUBLIC_CLOUDFLARE_ACCOUNT_HASH +
    "/" +
    (id ?? placeHolderImageId) +
    (assetSize == "small" ? "/width=200" : "/public")
  );
};

export const placeHolderImageId = "682b63d0-423b-4faa-2b1a-44e9d417a800";

export default generateAssetUrl;
